import { render } from "./BaseButton.vue?vue&type=template&id=63476905&scoped=true"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"

import "./BaseButton.vue?vue&type=style&index=0&id=63476905&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-63476905"

export default script